import utils from '@/mixins/utils'

/**
 * Filtra a lista de cadastros conforme os filtros selecionados.
 *
 * @param {Array<Object>} cadastros Lista de cadastros a serem filtrados.
 * @param {Boolean} exibirVermelhos Indica se devem ser exibidos apenas os cadastros vermelhos.
 * @param {Boolean} exibirVerdes Indica se devem ser exibidos apenas os cadastros verdes.
 * @param {Object|null} mes Mês selecionado no filtro.
 * @param {Object} equipe Equipe selecionada.
 *
 * @returns {Array<Object>} Lista de cadastros filtrados.
 */
export function filtro(
  cadastros,
  exibirVermelhos,
  exibirVerdes,
  mes = null,
  equipe
) {
  let cadastros_filtrados = cadastros

  if (exibirVermelhos === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      if (item.num_trat_concluido == 0) {
        return true
      }
    })
  }

  if (exibirVerdes === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      const tratConcluido = item.num_trat_concluido > 0

      if (!mes) {
        return tratConcluido
      }

      const mesesSelecionados = mes.value || []
      const anoSelecionado = mes.nu_ano

      let dados = []

      try {
        dados =
          typeof item.dados === 'string'
            ? JSON.parse(item.dados)
            : item.dados || []
      } catch (e) {
        dados = []
      }

      const registroMes = dados.find((dado) => {
        return (
          Number(dado.nm) === 1 &&
          mesesSelecionados.includes(Number(dado.nu_mes)) &&
          Number(dado.nu_ano) === Number(anoSelecionado) &&
          equipe.ine_esb == dado.nu_ine
        )
      })

      return tratConcluido && !!registroMes
    })
  }

  return cadastros_filtrados
}
